export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'yingshi',
    name: '影视资源',
    description: '最新热门电影、电视剧、网络剧资源一站式导航，高清流畅在线观看',
    icon: 'ri-movie-2-line',
    articleCount: 128,
  },
  {
    slug: 'zongyi',
    name: '综艺娱乐',
    description: '热门综艺、真人秀、脱口秀节目精选导航，精彩内容不容错过',
    icon: 'ri-tv-2-line',
    articleCount: 96,
  },
  {
    slug: 'dongman',
    name: '动漫番剧',
    description: '国内外热门动漫番剧资源导航，日漫国漫美漫一网打尽',
    icon: 'ri-ghost-smile-line',
    articleCount: 85,
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    description: 'BBC、国家地理等高品质纪录片资源导航，探索世界之美',
    icon: 'ri-earth-line',
    articleCount: 67,
  },
  {
    slug: 'tiyu',
    name: '体育赛事',
    description: 'NBA、英超、欧冠等热门体育赛事直播与回放导航',
    icon: 'ri-basketball-line',
    articleCount: 54,
  },
  {
    slug: 'xuexi',
    name: '学习教育',
    description: '优质在线课程、知识科普、技能学习资源导航，终身学习好帮手',
    icon: 'ri-book-open-line',
    articleCount: 73,
  },
  {
    slug: 'yinyue',
    name: '音乐MV',
    description: '热门音乐、MV、演唱会资源导航，尽享视听盛宴',
    icon: 'ri-music-2-line',
    articleCount: 61,
  },
  {
    slug: 'youxi',
    name: '游戏实况',
    description: '热门游戏实况、攻略解说、电竞赛事资源导航',
    icon: 'ri-gamepad-line',
    articleCount: 89,
  },
];